import {debounce, onBlockLoaded} from "@plaudit/frontend-apis";

onBlockLoaded({
	blockOrClassName: "plaudit-query-loop/results-count",
	onAdd(element) {
		const queryForm = element.closest("form");
		if (!queryForm) {
			return;
		}

		const debounced = debounce(() => {
			let count = 0;
			for (const result of queryForm?.querySelector(".wp-block-post-template")?.querySelectorAll("li") ?? []) {
				if (result.offsetParent !== null) {
					count++;
				}
			}

			let formatString: string;
			if (count === 0) {
				formatString = element.getAttribute("data-no-results") ?? "No results";
			} else if (count === 1) {
				formatString = element.getAttribute("data-one-result") ?? "%s result";
			} else {
				formatString = element.getAttribute("data-some-results") ?? "%s results";
			}
			const text = formatString.replaceAll("%s", count.toString());
			if (element.innerText !== text) {
				element.innerText = text;
			}
		}, 500);
		// We use a debounced mutation observer instead of the queryLoopFormUpdateComplete event because we need to account for hidden results
		const debouncedObserver = new MutationObserver(() => debounced());
		debouncedObserver.observe(queryForm, {childList: true, subtree: true, attributes: true});

		const observer = new MutationObserver(mutations => {
			for (const mutation of mutations) {
				for (const removedNode of mutation.removedNodes) {
					if (removedNode === element) {
						observer.disconnect();
						debouncedObserver.disconnect();
					}
				}
			}
		});
		observer.observe(element.parentElement!, {childList: true});
	}
});
